import React from 'react';
import { Space } from 'antd';
import { Retry } from '@components/common';
import { useCurrentKpiConfig } from '@src/hooks/useCurrentKpiConfig';
import Gauge from './SPIGauge';
import useFetchSPIData from './useFetchSPIData';
import { useWidget } from '../../state/dashboard';
import Trend from './Trend';
import { SPI_METRIC } from '@utils/kpi/spi';
import RemoveWidget from '../../control/RemoveWidget';
import useDiagDashboard from '../../hooks/useDiagDashboard';
import Drilldown from '../../control/Drilldown';
import WidgetCardWrapper from '../../common/WidgetCardWrapper';
import { DEFAULT_METRIC, SPI_QUERY_METRICS } from '../../utils/spi';
import { GaugeWrapper } from './styled';

export const SPIWidget = ({ wid }) => {
  const widgetHandler = useWidget({ wid });
  const currentKpi = useCurrentKpiConfig();

  const { isFetching, isError, data, refetch, queued } = useFetchSPIData({
    wid,
    metrics: SPI_QUERY_METRICS,
    currentKpi,
  });
  const totalsData = data?.totals;

  const { createDashboard } = useDiagDashboard({
    metrics: SPI_QUERY_METRICS,
    defaultMetric: DEFAULT_METRIC.spi,
    title: widgetHandler.meta.title,
  });

  return (
    <WidgetCardWrapper
      wid={wid}
      title={widgetHandler.meta.title}
      style={{ gridRow: 'span 7' }}
      extra={
        <Space>
          <Drilldown createDashboard={createDashboard} />
          <RemoveWidget onClick={widgetHandler.remove} />
        </Space>
      }
    >
      <Retry
        isLoading={isFetching}
        showError={isError}
        fetchData={refetch}
        progress={true}
        queued={queued}
      >
        <div>
          <GaugeWrapper>
            <Gauge key={'spi-guage'} currentKpi={currentKpi} data={totalsData} />
            <Trend metricKey={SPI_METRIC} data={data?.data[SPI_METRIC]} />
          </GaugeWrapper>
        </div>
      </Retry>
    </WidgetCardWrapper>
  );
};

export default SPIWidget;
